/**
 * i18n FR/EN — portail adhésion BT-GSD-KARATE-MEMBERSHIP-PORTAL-001.
 */
const FR = {
  homeCta: "Devenir membre",
  publicCalendar: {
    title: "Calendrier général",
    subtitle: "Événements publics de l'organisation — aucune donnée personnelle.",
    empty: "Aucun événement public trouvé.",
    columns: { date: "Date", title: "Titre", type: "Type", place: "Lieu" },
  },
  publicBd: {
    title: "Black Dragon",
    subtitle: "Adhésion privée supplémentaire — réservée aux membres Shotokan AAMC actifs.",
    empty: "Aucun contenu public Black Dragon.",
    mustBeMember: "Pour être Black Dragon, une personne doit être membre actif de Shotokan AAMC.",
  },
  dojo: {
    directions: "Itinéraire",
    phone: "Téléphone",
    email: "Courriel",
    instructor: "Instructeur principal",
  },
  wizard: {
    title: "Devenir membre",
    subtitle: "Inscription guidée — adhésion annuelle configurable.",
    stepKind: "Qui souhaitez-vous inscrire ?",
    adult: "Adulte",
    minor: "Mineur",
    stepIdentity: "Identité",
    stepHealth: "Formulaire santé",
    stepConsents: "Consentements",
    stepPayment: "Paiement",
    stepDone: "Adhésion activée",
    next: "Continuer",
    back: "Retour",
    submitHealth: "Enregistrer la santé",
    submitConsents: "Valider les consentements",
    pay: "Payer en démonstration",
    goLogin: "Ouvrir la connexion",
    activated: "Membre actif",
    sandboxNotice: "Paiement de démonstration — aucune carte réelle, aucun prélèvement.",
    feeLabel: "Cotisation annuelle",
    officialHealthPending: "Champs temporaires — le formulaire officiel Shotokan AAMC sera branché sans changer l'architecture.",
    missing: "Étape incomplète — complétez les champs obligatoires.",
    loginEmail: "Identifiant",
    loginPassword: "Mot de passe temporaire",
    parentManages: "Le parent gère ce profil — un seul compte parent peut suivre plusieurs enfants.",
  },
  fields: {
    firstName: "Prénom",
    lastName: "Nom",
    birthDate: "Date de naissance",
    address: "Adresse",
    city: "Ville",
    province: "Province",
    postalCode: "Code postal",
    phone: "Téléphone",
    email: "Courriel",
    dojo: "Dojo",
    instructor: "Instructeur",
    emergencyName: "Contact d'urgence — nom",
    emergencyRelation: "Lien",
    emergencyPhone: "Contact d'urgence — téléphone",
    parentFirstName: "Parent / responsable — prénom",
    parentLastName: "Parent / responsable — nom",
    parentRelation: "Relation",
    parentPhone: "Parent — téléphone",
    parentEmail: "Parent — courriel",
    yes: "Oui",
    no: "Non",
  },
  health: {
    titleAdult: "Santé — adulte",
    titleMinor: "Santé — mineur",
    hasMedicalConditions: "Condition médicale à déclarer",
    medicalConditionsDetails: "Précisions (si oui)",
    hasAllergies: "Allergies",
    allergiesDetails: "Précisions allergies (si oui)",
    hasMedications: "Médicaments",
    medicationsDetails: "Précisions médicaments (si oui)",
    activityRestrictions: "Restrictions d'activité",
    physicianName: "Médecin — nom",
    physicianPhone: "Médecin — téléphone",
    emergencyCareConsent: "J'autorise les soins d'urgence si nécessaire",
    accuracyAttestation: "Je confirme l'exactitude des informations",
    immunizationUpToDate: "Vaccination à jour (temporaire)",
    parentalHealthAuthority: "Autorité parentale — je complète ce formulaire pour le mineur",
  },
  consents: {
    privacy: "J'accepte la politique de confidentialité",
    healthAccuracy: "Je confirme les consentements santé requis",
    photoOptional: "Autorisation photo (optionnel)",
    parentalAuthority: "J'ai l'autorité parentale pour inscrire ce mineur",
  },
  payment: {
    method: "Mode de paiement",
    sandbox: "Démonstration",
    card: "Carte (jeton, sans numéro complet)",
    apple_pay: "Apple Pay",
    google_pay: "Google Pay",
    paypal: "PayPal",
    noPan: "Shotokan ne manipule jamais le numéro complet de carte.",
  },
  statuses: {
    draft: "Brouillon",
    form_incomplete: "Formulaire incomplet",
    health_pending: "Santé à compléter",
    payment_pending: "Paiement en attente",
    pending_approval: "En attente d'approbation",
    active: "Actif",
    expired: "Expiré",
    suspended: "Suspendu",
    cancelled: "Annulé",
  },
  bdStatuses: {
    not_member: "Non membre",
    request_submitted: "Demande soumise",
    invited: "Invité",
    pending_approval: "En attente approbation",
    active: "Actif",
    refused: "Refusé",
    withdrawn: "Retiré",
  },
  portal: {
    todayTitle: "Aujourd'hui",
    nextClass: "Prochain cours",
    nextEvent: "Prochain événement",
    reminders: "Rappels",
    calendarTitle: "Mon calendrier",
    calendarSubtitle: "Événements de votre dojo et événements généraux pertinents.",
    adhesionTitle: "Mon adhésion",
    adhesionSubtitle: "Statut, renouvellement et paiement.",
    examsTitle: "Mes examens",
    examsSubtitle: "Historique et prochain examen autorisé.",
    documentsTitle: "Mes documents",
    healthSelf: "Mes informations santé",
    healthHidden: "Informations santé protégées — accès non autorisé.",
    renewOn: "Fin de période",
    startOn: "Début",
    amount: "Montant",
    transaction: "Transaction",
    noClass: "Aucun cours à venir.",
    noEvent: "Aucun événement à venir.",
    emptyCalendar: "Aucun événement trouvé pour votre dojo.",
    bdTitle: "Black Dragon",
    bdRequest: "Demander à rejoindre Black Dragon",
    bdPending: "Demande Black Dragon en cours.",
    bdActive: "Adhésion Black Dragon active.",
    bdNeedMember: "Cette personne doit d'abord devenir membre de Shotokan AAMC.",
    bdPrivate: "Contenu privé Black Dragon",
    bdHidden: "Ce contenu est réservé aux membres Black Dragon.",
    bdInviteHint: "Sur invitation ou demande, avec validation administrative.",
  },
  parent: {
    title: "Adhésion des enfants",
    subtitle: "Choisissez un enfant pour voir calendrier, progression, adhésion et formulaires autorisés.",
    selectChild: "Enfant",
    noChild: "Aucun enfant lié.",
  },
  admin: {
    title: "Cockpit d'adhésion",
    subtitle: "Inscriptions, paiements, santé, membres actifs, renouvellements et Black Dragon.",
    tabs: {
      inProgress: "Inscriptions en cours",
      payments: "Paiements en attente",
      health: "Formulaires santé incomplets",
      active: "Membres actifs",
      renewals: "Renouvellements",
      bdRequests: "Demandes Black Dragon",
      bdInvites: "Invitations Black Dragon",
    },
    columns: {
      who: "Qui",
      kind: "Type",
      missing: "Étape manquante",
      status: "Statut",
      dojo: "Dojo",
      email: "Courriel",
    },
    empty: "Aucune inscription trouvée.",
    emptyFiltered: "Aucun résultat — réinitialisez les filtres.",
    open360: "Fiche 360",
    inviteBd: "Inviter Black Dragon",
    approveBd: "Approuver",
    refuseBd: "Refuser",
    fee: "Cotisation annuelle",
    saveFee: "Enregistrer le montant",
    member360Title: "Fiche membre",
    healthAudit: "Journal santé",
    roles: "Rôles",
    history: "Historique",
    adult: "Adulte",
    minor: "Mineur",
    sectionIdentity: "Identité",
    sectionContact: "Coordonnées",
    sectionDojo: "Dojo",
    sectionInstructor: "Instructeur",
    sectionGrade: "Grade / progression",
    sectionParent: "Parent / responsable",
    sectionMembership: "Adhésion",
    sectionHealth: "Santé — accès protégé",
    sectionHistory: "Historique / source",
    toComplete: "À compléter",
    toVerify: "À vérifier",
    emailToVerify: "Courriel à vérifier",
  },
  officialImport: {
    title: "Membres officiels CKA",
    subtitle: "Étudiants importés des instructeurs Shotokan AAMC — sans compte de connexion automatique.",
    dryRun: "Aperçu (dry run)",
    apply: "Importer / réappliquer",
    applied: "Import appliqué (idempotent).",
    yannickZero: "0 trouvé — aucun membre inventé",
    columns: {
      name: "Nom",
      instructor: "Instructeur",
      dojo: "Dojo",
      grade: "Grade",
      status: "Statut",
      kind: "Type",
    },
    empty: "Aucun membre officiel trouvé.",
    emptyFiltered: "Aucun résultat — réinitialisez les filtres.",
    review: "À vérifier",
    source: "Provenance CKA 2025-26",
    noLogin: "Aucun compte de connexion créé par cet import.",
    healthHiddenList: "Les informations médicales ne sont jamais affichées dans cette liste.",
    richardAdded: "Richard Pik ajouté sous Gilles Lavigne.",
    hanshiTitle: "Hanshi",
    organisation: "Shotokan",
  },
  vis: {
    public: "Public",
    shotokan_members: "Membres Shotokan",
    black_dragon: "Black Dragon uniquement",
    admin: "Administration uniquement",
  },
};

const EN = {
  homeCta: "Become a member",
  publicCalendar: {
    title: "General calendar",
    subtitle: "Public organization events — no personal data.",
    empty: "No public event found.",
    columns: { date: "Date", title: "Title", type: "Type", place: "Place" },
  },
  publicBd: {
    title: "Black Dragon",
    subtitle: "Additional private membership — for active Shotokan AAMC members.",
    empty: "No public Black Dragon content.",
    mustBeMember: "To be Black Dragon, a person must be an active Shotokan AAMC member.",
  },
  dojo: {
    directions: "Directions",
    phone: "Phone",
    email: "Email",
    instructor: "Lead instructor",
  },
  wizard: {
    title: "Become a member",
    subtitle: "Guided registration — configurable annual membership.",
    stepKind: "Who do you want to register?",
    adult: "Adult",
    minor: "Minor",
    stepIdentity: "Identity",
    stepHealth: "Health form",
    stepConsents: "Consents",
    stepPayment: "Payment",
    stepDone: "Membership activated",
    next: "Continue",
    back: "Back",
    submitHealth: "Save health form",
    submitConsents: "Confirm consents",
    pay: "Pay in demo mode",
    goLogin: "Open sign-in",
    activated: "Active member",
    sandboxNotice: "Demo payment — no real card, no live charge.",
    feeLabel: "Annual fee",
    officialHealthPending: "Temporary fields — the official Shotokan AAMC form will plug in without changing the architecture.",
    missing: "Incomplete step — fill in the required fields.",
    loginEmail: "Sign-in identifier",
    loginPassword: "Temporary password",
    parentManages: "The parent manages this profile — one parent account can follow several children.",
  },
  fields: {
    firstName: "First name",
    lastName: "Last name",
    birthDate: "Date of birth",
    address: "Address",
    city: "City",
    province: "Province",
    postalCode: "Postal code",
    phone: "Phone",
    email: "Email",
    dojo: "Dojo",
    instructor: "Instructor",
    emergencyName: "Emergency contact — name",
    emergencyRelation: "Relationship",
    emergencyPhone: "Emergency contact — phone",
    parentFirstName: "Parent / guardian — first name",
    parentLastName: "Parent / guardian — last name",
    parentRelation: "Relationship",
    parentPhone: "Parent — phone",
    parentEmail: "Parent — email",
    yes: "Yes",
    no: "No",
  },
  health: {
    titleAdult: "Health — adult",
    titleMinor: "Health — minor",
    hasMedicalConditions: "Medical condition to declare",
    medicalConditionsDetails: "Details (if yes)",
    hasAllergies: "Allergies",
    allergiesDetails: "Allergy details (if yes)",
    hasMedications: "Medications",
    medicationsDetails: "Medication details (if yes)",
    activityRestrictions: "Activity restrictions",
    physicianName: "Physician — name",
    physicianPhone: "Physician — phone",
    emergencyCareConsent: "I authorize emergency care if needed",
    accuracyAttestation: "I confirm the information is accurate",
    immunizationUpToDate: "Immunization up to date (temporary)",
    parentalHealthAuthority: "Parental authority — I complete this form for the minor",
  },
  consents: {
    privacy: "I accept the privacy policy",
    healthAccuracy: "I confirm the required health consents",
    photoOptional: "Photo authorization (optional)",
    parentalAuthority: "I have parental authority to register this minor",
  },
  payment: {
    method: "Payment method",
    sandbox: "Demo",
    card: "Card (token, no full number)",
    apple_pay: "Apple Pay",
    google_pay: "Google Pay",
    paypal: "PayPal",
    noPan: "Shotokan never handles the full card number.",
  },
  statuses: {
    draft: "Draft",
    form_incomplete: "Incomplete form",
    health_pending: "Health form to complete",
    payment_pending: "Payment pending",
    pending_approval: "Pending approval",
    active: "Active",
    expired: "Expired",
    suspended: "Suspended",
    cancelled: "Cancelled",
  },
  bdStatuses: {
    not_member: "Not a member",
    request_submitted: "Request submitted",
    invited: "Invited",
    pending_approval: "Pending approval",
    active: "Active",
    refused: "Refused",
    withdrawn: "Withdrawn",
  },
  portal: {
    todayTitle: "Today",
    nextClass: "Next class",
    nextEvent: "Next event",
    reminders: "Reminders",
    calendarTitle: "My calendar",
    calendarSubtitle: "Events for your dojo and relevant general events.",
    adhesionTitle: "My membership",
    adhesionSubtitle: "Status, renewal and payment.",
    examsTitle: "My exams",
    examsSubtitle: "History and next authorized exam.",
    documentsTitle: "My documents",
    healthSelf: "My health information",
    healthHidden: "Protected health information — access not authorized.",
    renewOn: "Period end",
    startOn: "Start",
    amount: "Amount",
    transaction: "Transaction",
    noClass: "No upcoming class.",
    noEvent: "No upcoming event.",
    emptyCalendar: "No event found for your dojo.",
    bdTitle: "Black Dragon",
    bdRequest: "Ask to join Black Dragon",
    bdPending: "Black Dragon request in progress.",
    bdActive: "Active Black Dragon membership.",
    bdNeedMember: "This person must first become a Shotokan AAMC member.",
    bdPrivate: "Private Black Dragon content",
    bdHidden: "This content is reserved for Black Dragon members.",
    bdInviteHint: "By invitation or request, with administrative validation.",
  },
  parent: {
    title: "Children membership",
    subtitle: "Choose a child to see calendar, progress, membership and authorized forms.",
    selectChild: "Child",
    noChild: "No linked child.",
  },
  admin: {
    title: "Membership cockpit",
    subtitle: "Registrations, payments, health, active members, renewals and Black Dragon.",
    tabs: {
      inProgress: "Registrations in progress",
      payments: "Pending payments",
      health: "Incomplete health forms",
      active: "Active members",
      renewals: "Renewals",
      bdRequests: "Black Dragon requests",
      bdInvites: "Black Dragon invitations",
    },
    columns: {
      who: "Who",
      kind: "Type",
      missing: "Missing step",
      status: "Status",
      dojo: "Dojo",
      email: "Email",
    },
    empty: "No membership found.",
    emptyFiltered: "No result — reset the filters.",
    open360: "360 profile",
    inviteBd: "Invite to Black Dragon",
    approveBd: "Approve",
    refuseBd: "Refuse",
    fee: "Annual fee",
    saveFee: "Save amount",
    member360Title: "Member profile",
    healthAudit: "Health log",
    roles: "Roles",
    history: "History",
    adult: "Adult",
    minor: "Minor",
    sectionIdentity: "Identity",
    sectionContact: "Contact details",
    sectionDojo: "Dojo",
    sectionInstructor: "Instructor",
    sectionGrade: "Rank / progress",
    sectionParent: "Parent / guardian",
    sectionMembership: "Membership",
    sectionHealth: "Health — protected access",
    sectionHistory: "History / source",
    toComplete: "To complete",
    toVerify: "To verify",
    emailToVerify: "Email to verify",
  },
  officialImport: {
    title: "Official CKA members",
    subtitle: "Students imported for Shotokan AAMC instructors — no automatic login accounts.",
    dryRun: "Preview (dry run)",
    apply: "Import / re-apply",
    applied: "Import applied (idempotent).",
    yannickZero: "0 found — no member invented",
    columns: {
      name: "Name",
      instructor: "Instructor",
      dojo: "Dojo",
      grade: "Rank",
      status: "Status",
      kind: "Type",
    },
    empty: "No official member found.",
    emptyFiltered: "No result — reset the filters.",
    review: "To verify",
    source: "CKA 2025-26 provenance",
    noLogin: "No login account was created by this import.",
    healthHiddenList: "Medical information is never shown in this list.",
    richardAdded: "Richard Pik added under Gilles Lavigne.",
    hanshiTitle: "Hanshi",
    organisation: "Shotokan",
  },
  vis: {
    public: "Public",
    shotokan_members: "Shotokan members",
    black_dragon: "Black Dragon only",
    admin: "Administration only",
  },
};

export function getMembershipCopy(locale = "fr") {
  return locale === "en" ? EN : FR;
}

export function formatFee(cents, currency = "CAD", locale = "fr") {
  const value = (Number(cents) || 0) / 100;
  try {
    return new Intl.NumberFormat(locale === "en" ? "en-CA" : "fr-CA", {
      style: "currency",
      currency,
    }).format(value);
  } catch {
    return `${value.toFixed(2)} $`;
  }
}
